<template>
  <article v-if="text">
    <div class="prose prose--app max-w-none" :class="{ 'prose--app--lid': $route.meta.style === 'lid' }" v-html="text" />
  </article>
</template>

<script setup lang="ts">
interface Props {
  text?: string
}

defineProps<Props>()
</script>
